import { type ThemeConfig, theme } from "antd";

export const lightThemeConfig: ThemeConfig = {
  "token": {
    "colorPrimary": "#381e17",
    "colorBgBase": "#502A1E",
    "colorTextBase": "#321a12",
    "colorError": "#c70003",
    "colorPrimaryBg": "#ac38bd4a",
    "colorFillTertiary": "#321a1236",
    "colorFillQuaternary": "#321a121c",
    "colorBgElevated": "rgb(216,179,114)",
    "colorBgContainer": "rgba(223,189,152, 0.7)",
    "colorPrimaryBgHover": "#be753e9e",
    "borderRadius": 12,
    "colorLink": "#381e17",
    "boxShadow": "rgba(0, 0, 0, 0.35) 0px 5px 15px",
    "colorTextPlaceholder": "rgba(0,0,0,0.56)",
    "colorTextDisabled": "rgba(25,25,25,0.5)",
    "colorSuccess": "rgb(69,161,23)",
    "colorWarning": "rgb(234,121,0)",
    "colorInfo": "#1160cf",
    // the width of the focus border - useful for keyboard support
    "lineWidthFocus": 2,

    "colorTextSecondary": "rgba(50,26,18,0.65)",
    "colorTextTertiary": "rgba(50,26,18,0.45)",
    "colorTextQuaternary": "rgba(0,0,0,0.65)",
    "colorTextDescription": "rgba(50,26,18,0.65)", //origin: colorTextTertiary
  },
  "components": {
    "Drawer": {
      "colorBgElevated": "rgba(223,189,152, 1)",
      "colorText": "#321a12",
      "colorIcon": "#321a12"
    },
    "Button": {
      "colorPrimary": "rgb(148,47,175)",
      "colorPrimaryHover": "rgb(179,86,204)",
      "borderRadius": 12,
      "boxShadow": "rgba(0, 0, 0, 0.35) 0px 5px 15px",
      "dangerShadow": "0",
      "defaultShadow": "0",
      "primaryShadow": "0",
      "colorPrimaryActive": "rgb(123,48,143)",
      "colorBorder": "rgb(117,32,140)",
      "colorTextDisabled": "rgba(0,0,0,0.5)"
    },
    "Typography": {
      "colorWarning": "rgb(242,142,11)"
    },
    "Rate": {
      "starColor": "rgb(119,74,183)",
      "starBg": "rgba(0,0,0,0.27)"
    },
    "Select": {
      "multipleItemBg": "rgb(229,184,108)",
      "colorBgBase": "rgb(232,189,11)"
    },
    "Card": {
      "borderRadius": 16,
      "bodyPadding": 12,
      "boxShadow": "rgba(0, 0, 0, 0.35) 0px 5px 15px",
      "boxShadowTertiary": "rgba(0, 0, 0, 0.35) 0px 5px 15px"
    },
    "Input": {
      "borderRadius": 10,
      "boxShadow": "rgba(0, 0, 0, 0.35) 0px 5px 15px"
    },
    "Layout": {
      "headerBg": "rgba(38,23,19, 1)"
    },
    "Table": {
      "headerBorderRadius": 0
    },
    "Menu": {
      "colorBgContainer": "rgba(0,0,0,0)",
      "darkItemBg": "rgba(0,0,0,0)",
      "itemBg": "rgba(0,0,0,0)",
      "activeBarBorderWidth": 2,
      "itemColor": 'rgba(255,255,255,0.65)',
      "itemHoverColor": 'rgba(255,255,255,1)',
      "itemDisabledColor": 'rgba(255,255,255,0.25)',
      "horizontalItemSelectedColor": 'rgba(255,255,255,0.65)',
    },
    "Radio": {
      "buttonCheckedBg": "rgb(179,143,193)",
      "buttonSolidCheckedBg": "rgb(179,143,193)",
      "buttonSolidCheckedColor": "rgb(0,0,0)",
      "buttonSolidCheckedHoverBg": "rgb(150,114,164)",
      "buttonSolidCheckedActiveBg": "rgb(137,105,150)"
    },
    "Segmented": {
      "trackBg": "rgb(150,115,156)"
    },
    "Progress": {
      "remainingColor": "rgba(0,0,0,0.13)",
      "defaultColor": "rgb(148,33,186)"
    },
    "Carousel": {
      "colorBgContainer": "rgb(111,0,151)",
      "dotHeight": 10,
      "dotWidth": 24,
      "dotActiveWidth": 32,
      "dotOffset": 0
    }
  },
  algorithm: [theme.defaultAlgorithm],
  cssVar: true,
};

export const darkThemeConfig: ThemeConfig = {

  "token": {
    "colorError": "rgb(237,65,68)",
    "borderRadius": 12,
    "boxShadow": "rgba(0, 0, 0, 0.35) 0px 5px 15px",
    "colorPrimary": "#1b1c20",
    "colorTextBase": "#ffffff",
    "colorBgBase": "#28303f",
    "colorTextPlaceholder": "rgba(255,255,255,.56)",
    "colorLink": "rgb(101,163,210)",
    "colorLinkHover": "rgb(255,255,255)",
    "colorLinkActive": "rgb(168,204,231)",
    "colorBgContainer": "rgba(33,46,70, 0.7)",
    "colorBorderSecondary": "rgb(111,125,129)",
    "colorInfo": "#136ae4",
    "blue":    "#589bfa",
    "purple":  "#9e68ed",
    "cyan":    "#13C2C2",
    "green":   "#52C41A",
    "magenta": "#EB2F96",
    "pink":    "#EB2F96",
    "red":     "#ea3038",
    "orange":  "#FA8C16",
    "yellow":  "#FADB14",
    "volcano": "#FA541C",
    "geekblue":"#537ce1",
    "gold":    "#FAAD14",
    "lime":    "#A0D911",
  },
  "components": {
    "Drawer": {
      "colorBgElevated": "rgb(29,29,31)",
      "colorText": "rgba(255,255,255,0.65)",
      "colorIcon": "rgba(255,255,255,0.65)"
    },
    "Layout": {
      "headerBg": "rgb(29,29,31)"
    },
    "Button": {
      "boxShadow": "rgba(0, 0, 0, 0.35) 0px 5px 15px",
      "dangerShadow": "0",
      "defaultShadow": "0",
      "primaryShadow": "0",
      "colorPrimary": "rgb(69,173,225)",
      "colorPrimaryBgHover": "rgb(69,173,225)",
      "defaultHoverBorderColor": "rgb(69,173,225)",
      "defaultHoverColor": "rgb(69,173,225)",
      "defaultGhostColor": "rgb(69,173,225)",
      "defaultBorderColor": "rgb(69,173,225)",
      "textTextColor": "rgb(69,173,225)",
      "defaultActiveColor": "rgb(255,255,255)",
      "defaultActiveBorderColor": "rgb(69,173,225)",
      "colorPrimaryHover": "rgb(10,108,174)",
      "colorPrimaryActive": "rgb(7,77,124)"
    },
    "Typography": {
      "colorWarning": "rgb(242,142,11)",
      "colorLink": "rgb(143,227,242)",
      "colorLinkHover": "rgb(76,178,196)"
    },
    "Anchor": {
      "colorText": "rgba(181,237,247,0.88)"
    },
    "Divider": {
      "colorSplit": "rgba(140,140,174,0.31)"
    },
    "Menu": {
      "colorBgContainer": "rgba(0,0,0,0)",
      "darkItemBg": "rgba(0,0,0,0)",
      "itemBg": "rgba(0,0,0,0)",
      "activeBarBorderWidth": 2,
      "itemColor": 'rgba(255,255,255,0.65)',
      "itemHoverColor": 'rgba(255,255,255,1)',
      "itemDisabledColor": 'rgba(255,255,255,0.25)',
      "horizontalItemSelectedColor": 'rgba(255,255,255,0.65)',
      "subMenuItemSelectedColor": "rgb(102,168,194)",
      "itemSelectedColor": "rgb(230,244,255)",
    },
    "Pagination": {
      "colorPrimary": "rgb(184,198,255)"
    },
    "Input": {
      "colorBorder": "rgb(115,124,139)",
      "hoverBorderColor": "rgb(153,171,202)"
    },
    "InputNumber": {
      "colorBorder": "rgb(115,124,139)",
      "hoverBorderColor": "rgb(153,171,202)"
    },
    "Radio": {
      "buttonSolidCheckedActiveBg": "rgb(81,125,201)",
      "buttonSolidCheckedBg": "rgb(121,150,199)",
      "buttonSolidCheckedHoverBg": "rgb(97,135,201)",
      "colorPrimaryHover": "rgb(121,150,199)",
      "colorPrimary": "rgb(121,150,199)"
    },
    "Switch": {
      "colorPrimary": "rgb(87,130,202)",
      "colorPrimaryHover": "rgb(121,150,199)"
    },
    "Checkbox": {
      "colorBorder": "rgb(181,237,247)"
    },
    "Card": {
      "bodyPadding": 12,
      "colorBgContainer": "rgba(29,29,31,0.7)",
      "headerBg": "rgba(34,33,36,0.7)",
      "colorBorderSecondary": "rgb(41,44,45)"
    },
    "Collapse": {
      "contentBg": "rgb(27,27,27)",
      "headerBg": "rgba(28,43,54,0.4)"
    },
    "Select": {
      "optionSelectedBg": "rgba(159,208,245,0.37)",
      "multipleItemBg": "rgba(159,208,245,0.37)"
    },
    "Slider": {
      "trackBg": "rgba(159,208,245,0.61)",
      "trackHoverBg": "rgba(159,208,245,0.75)",
      "railBg": "rgba(255,255,255,0.13)",
      "handleColor": "rgba(129,175,210,0.9)",
      "colorPrimaryBorderHover": "rgb(180,221,253)",
      "colorBgElevated": "rgb(51,77,96)"
    },
    "Tooltip": {
      "colorBgSpotlight": "rgb(69,106,134)"
    },

    "Timeline": {
      "tailColor": "rgb(25,91,142)",
      "dotBg": "rgba(0,0,0,0)",
      "colorPrimary": "rgb(101,163,210)",
      "dotBorderWidth": 1,
      "tailWidth": 2
    },
    "Steps": {
      "colorPrimary": "rgb(101,163,210)",
      "colorSplit": "rgba(167,167,186,0.31)"
    },
    "Badge": {
      "colorInfo": "rgb(19,194,194)"
    },
    "Table": {
      "headerBorderRadius": 0,
      "colorBgContainer": "rgba(36,36,57,0.7)",
      "colorPrimary": "rgb(168,204,231)",
      "headerBg": "rgba(27,28,41,0.7)",
      "headerColor": "rgba(255,255,255,0.88)",
      "headerSortActiveBg": "rgba(37,50,74,0.7)",
      "headerSortHoverBg": "#2e3b51",
      "bodySortBg": "rgba(37,50,74,0.7)",
      "rowHoverBg": "rgba(37,50,74,0.7)",
      "rowSelectedBg": "#5b5d61",
      "rowSelectedHoverBg": "#4f5154",
      "borderColor": "#172031",
      "footerBg": "#25324a",
      "footerColor": "rgba(255,255,255,0.88)",
      "headerSplitColor": "#172031",
      "headerFilterHoverBg": "rgba(255,255,255,0.06)",
      "filterDropdownMenuBg": "#212e46",
      "filterDropdownBg": "#212e46",
      "expandIconBg": "#212e46"
    },
    "Tabs": {
      "itemColor": "rgba(168,204,231,0.88)",
      "itemActiveColor": "rgb(255,255,255)",
      "itemSelectedColor": "rgb(255,255,255)",
      "itemHoverColor": "rgb(255,255,255)"
    },
    "Alert": {
      "colorInfo": "rgb(168,204,231)",
      "colorInfoBorder": "rgb(168,204,231)",
      "colorErrorBg": "rgba(247,48,51,0.16)",
      "colorErrorBorder": "rgb(247,48,51)",
      "colorError": "rgb(247,48,51)",
      "colorInfoBg": "rgba(168,204,231,0.15)",
      "colorSuccessBg": "rgba(83,196,26,0.15)",
      "colorWarningBorder": "rgb(250,173,20)",
      "colorWarningBg": "rgba(250,173,20,0.15)"
    },
    "Message": {
      "colorInfo": "rgb(168,204,231)"
    },
    "Notification": {
      "colorInfo": "rgb(168,204,231)"
    },
    "Progress": {
      "defaultColor": "rgb(57,94,121)",
      "remainingColor": "rgb(59,57,57)"
    },
    "Skeleton": {
      "gradientToColor": "rgba(255,255,255,0.28)"
    },
    "Spin": {
      "colorPrimary": "rgb(227,161,253)"
    },
    "Tag": {
      "defaultBg": "rgba(29,71,104,0.15)",
      "colorBorder": "rgba(72,85,103,0.51)",
      "colorInfoBg": "#1e2640",
      "colorInfoBgHover": "#172640",
      "colorInfoBorder": "#30476e",
      "colorInfoBorderHover" : "#214373",
      "colorInfoHover": "#214373",
      "colorInfo": "#3779d3",
      "colorInfoActive": "#27589d",
      "colorInfoTextHover": "#5492df",
      "colorInfoText": "#2d6dc7",
      "colorInfoTextActive": "#27589d",
    }
  },
  algorithm: [theme.darkAlgorithm],
  cssVar: true,
};
